import React, { useEffect, useState } from "react";
import { Table } from "antd";

const TableCharts = ({ single }) => {
	const [columnData, setcolumnData] = useState([]);
	const [finalDataSource, setfinalDataSource] = useState([]);
    const [visiblePagination, setvisiblePagination] = useState(false);
	const dataSource = finalDataSource;
	
	useEffect(() => {
		//dataset for column names
		let newdata = [];		
		single[0]?.x?.map((e, i) => {
			return newdata.push({
				title: e,
				dataIndex: e.toLowerCase(),
				key: e.toLowerCase(),
			});
		});
		newdata.push({
			title: "Total mention count",
			dataIndex: "total mention count",
			key: "total mention count",
		});
		setcolumnData(newdata);

		//dataset for entries in columns
		let newdataY = [];
		let obj = {};
		let sum = 0;
		single[0]?.y?.map((e, i) => {
			sum = sum + e;
			return (obj[newdata[i].dataIndex] = e);
		});
		obj[newdata[newdata?.length - 1].dataIndex] = sum;
		newdataY?.push(obj);
		setfinalDataSource(newdataY);
	}, [single]);

	const columns = columnData;

    useEffect(() => {
		if (dataSource?.length > 10) {
			setvisiblePagination(true);
		} else {
			setvisiblePagination(false);
		}
	}, []);

	return (
		<div className="pl-15 pr-15">
			<Table 
			dataSource={dataSource} 
			//bordered 
			columns={columns} 
			pagination={visiblePagination}
			scroll={{
				x: 100,
			  }} />
		</div>
	);
};

export default TableCharts;
